export default __webpack_public_path__ + "static/media/infant.48d7de4a.svg";